// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"48":"92b66265","66":"a82b85a4","273":"01399023","295":"d2041fc7","330":"b017ab11","417":"4c2fcc8a","437":"56fb7fe2","538":"66f07ce7","563":"76b0edad","570":"f74e63a2","599":"6380a8fa","873":"3898b782","940":"eb8bcdc6"}[chunkId] + ".chunk.js";
};